import React, { useState, forwardRef } from "react";
import useAppStore from "../../../stores/appStore";
import {
  selectedAssistantSelector,
  systemModeSelector,
  setIsWebSnippetOpenSelector,
  setSystemModeSelector,
  hasPermissionSelector
} from "../../../stores/selectors/appSelectors";
import { ASSISTANT_CHANNELS, BRANCH_NAMES, ASSISTANT_TYPES } from "@consts";
import { SYSTEM_MODES } from "src/stores/slices/createAppSlice";
import PreviewButton from "./preview-button/PreviewButton";
import PreviewDropdown from "./PreviewDropdown";
import CallMeManager from "../call-me/call-me-manager/CallMeManager";
import SharePreviewDialog from "./SharePreviewDialog";
import { notifyToggleWidget } from "../../../analytics/notifyCustomActions";
import { USER_PERMISSIONS } from "@hyro/dashboard-permissions";
import { useDraft } from "src/queries/hooks/assistants";

const PreviewManager = forwardRef((props, ref) => {
  const systemMode = useAppStore(systemModeSelector);
  const setSystemMode = useAppStore(setSystemModeSelector);
  const setIsWebSnippetOpen = useAppStore(setIsWebSnippetOpenSelector);
  const hasPermission = useAppStore(hasPermissionSelector);
  const selectedAssistant = useAppStore(selectedAssistantSelector);
  const { data: draft } = useDraft();
  const [anchorEl, setAnchorEl] = useState(null);
  const [phoneDialogOpen, setPhoneDialogOpen] = useState(false);
  const [isSharePreviewDialogOpen, setIsSharePreviewDialogOpen] = useState(false);

  const isPhone = selectedAssistant?.channel === ASSISTANT_CHANNELS.PHONE;
  const isLiveAgent = selectedAssistant?.type === ASSISTANT_TYPES.LIVE;
  const branchName = systemMode === SYSTEM_MODES.EDIT ? draft?.branchName : isLiveAgent ? undefined : BRANCH_NAMES.MASTER;

  const handleOpenDropdown = (event) => {
    if (hasPermission(USER_PERMISSIONS.SHARE_PREVIEW.READ)) {
      setAnchorEl(event.currentTarget);
    } else {
      if (isPhone) setPhoneDialogOpen(true);
      else handleOpenWidget();
    }
  };

  const handleOpenWidget = () => {
    notifyToggleWidget("Opened");
    setSystemMode(SYSTEM_MODES.PREVIEW);
    setIsWebSnippetOpen(true);
  };

  return (<>
    <PreviewButton handleOpenDropdown={handleOpenDropdown} ref={ref} />

    <PreviewDropdown anchorEl={anchorEl} setAnchorEl={setAnchorEl} setPhoneDialogOpen={setPhoneDialogOpen} setIsSharePreviewDialogOpen={setIsSharePreviewDialogOpen} handleOpenWidget={handleOpenWidget} />

    <SharePreviewDialog isSharePreviewDialogOpen={isSharePreviewDialogOpen} setIsSharePreviewDialogOpen={setIsSharePreviewDialogOpen} />

    <CallMeManager phoneDialogOpen={phoneDialogOpen} setPhoneDialogOpen={setPhoneDialogOpen} branchName={branchName} />
  </>
  );
});

PreviewManager.displayName = "PreviewManager";

export default PreviewManager;
